module.exports = __webpack_public_path__ + "static/media/angle_down.0e98d14a.svg";